<div class="min-h-screen">
  <app-shared-layout
    [Analysis]="title"
    [hideAdd]="true"
    animationSize="full"
    [secondaryWithStyle]="false"
  >
    <div ngProjectAs="primary-panel">
      <div class="flex flex-col mt-5">
        <div class="flex flex-col">
          <div class="flex justify-start mt-4">
            <div class="flex items-center gap-3">
              @if (sensor$ | async; as sensors) {
                <select
                  (change)="changeSensor($event)"
                  name="sensorSelector"
                  class="px-4 py-2 text-base font-semibold bg-gradient-to-r from-blue-100 to-blue-200 text-black rounded-xl border border-blue-300 shadow-md focus:outline-none"
                  title="sensorSelector"
                  id=""
                >
                  @for (sensor of sensors; track $index) {
                    <option
                      [value]="sensor?.uniqueId"
                      [selected]="sensor.uniqueId == sensorId"
                    >
                      {{ sensor?.sensorName }}
                    </option>
                  }
                </select>
              }
            </div>
          </div>

          <div style="height: 0px"></div>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-4 xl:grid-cols-5 gap-5">
        <!-- Left Summary (20%) -->
        <div class="flex flex-col gap-5 md:col-span-1 xl:col-span-1">
          <div class="p-4 rounded-xl shadow-lg flex flex-col h-[350px]">
            <span class="font-bold">Real Time Temperature</span>
            <div class="grid w-full h-full">
              <div
                class="relative bg-red-50 text-xl lg:text-[2.5vw] xl:text-[2vw] text-red-500 p-2 font-bold flex items-center justify-center h-full"
              >
                <fa-icon [icon]="faTemperature4"></fa-icon>
                {{
                  dashboardRealtimeSummary?.temperature | number: "1.2-2"
                }}&deg;C
                <span
                  class="absolute bottom-0 right-1 text-[10px] text-red-400 uppercase"
                >
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardRealtimeSummary?.created_date }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-4 rounded-xl shadow-lg flex flex-col h-[350px]">
            <span class="font-bold">Real Time Humidity</span>
            <div class="grid w-full h-full">
              <div
                class="relative text-xl lg:text-[2.5vw] xl:text-[2vw] bg-blue-50 text-blue-500 p-2 font-bold flex items-center justify-center h-full"
              >
                <fa-icon [icon]="faDroplet"></fa-icon>
                {{ dashboardRealtimeSummary?.humidity | number: "1.2-2" }}%
                <span
                  class="absolute bottom-0 right-1 text-[10px] text-blue-500 uppercase"
                >
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardRealtimeSummary?.created_date }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Graph Card (60%) -->
        <div class="flex flex-col gap-5 md:col-span-3 xl:col-span-3">
          <div class="bg-white rounded-xl shadow-lg p-4 flex flex-col">
            <!-- Title + Tabs -->
            <div class="flex items-center justify-between">
              <p class="text-primary text-md font-bold">Temperature and Humidity Readings Visualization</p>
              <div
                class="w-[200px] h-[32px] bg-gray-100 rounded-full flex items-center px-1 shadow-sm"
              >
                <div class="flex gap-1 w-full px-[2px]">
                  @for (tab of lineChartsTabs; track tab) {
                    <div
                      (click)="onTabChange(tab.slug)"
                      [ngClass]="{
                        'bg-primary text-white rounded-full':
                          activeSlugLineCharts === tab.slug,
                        'text-gray-500': activeSlugLineCharts !== tab.slug,
                      }"
                      class="cursor-pointer text-[12px] font-medium px-3 h-[24px] flex items-center justify-center text-center truncate transition-colors duration-200"
                      style="
                        max-width: 150px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ tab.name }}
                    </div>
                  }
                </div>
              </div>
            </div>

            <!-- Filters + Live -->
            <div class="flex items-center justify-between mt-2">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-2 w-full">
                <div class="flex gap-1 items-center">
                  <span>From</span>
                  <input
                    type="datetime-local"
                    [(ngModel)]="sixHoursPast"
                    [max]="currentTime"
                    (change)="onTimeChange()"
                    class="date-input py-1 px-2 border rounded text-sm w-full"
                  />
                </div>
                <div class="flex gap-1 items-center">
                  <span>To</span>
                  <input
                    type="datetime-local"
                    [(ngModel)]="currentTime"
                    [min]="sixHoursPast"
                    (change)="onTimeChange()"
                    class="date-input py-1 px-2 border rounded text-sm w-full"
                  />
                </div>
              </div>

              <button
                matTooltip="Click to toggle live graph"
                (click)="setFetchStatus()"
                class="live-button px-3 flex items-center gap-2 rounded shadow-sm"
              >
                <span
                  class="status-dot"
                  [ngClass]="{
                    'pulse-button': fetchStatus === 'live',
                    'pulse-not-live': fetchStatus === 'fixed',
                  }"
                ></span>
                <span>Live</span>
              </button>
            </div>

            <!-- Chart -->
            @if (loadingData) {
              <div class="skeleton-wrapper mt-2">
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{ height: '580px', width: '100%' }"
                ></ngx-skeleton-loader>
              </div>
            } @else {
              <div class="flex-grow h-full mt-2">
                <app-bar-graph
                  *ngIf="
                    activeSlugLineCharts === 'lineChartsTemp';
                    else humidityGraph
                  "
                  title="Temperature"
                  [data]="tempLineChartsData"
                  [width]="'100%'"
                  [height]="580"
                  [gridX]="false"
                  [gridY]="true"
                  [xAxis]="xAxis"
                  [showXlabel]="true"
                  [showYlabel]="true"
                  columnWidth="25%"
                  chart_type="area"
                  LegendPosition="top"
                  horizontalAlign="right"
                ></app-bar-graph>
                <ng-template #humidityGraph>
                  <app-bar-graph
                    title="Humidity"
                    [data]="humLineChartsData"
                    [width]="'100%'"
                    [height]="580"
                    [gridX]="false"
                    [gridY]="true"
                    [xAxis]="xAxis"
                    [showXlabel]="true"
                    [showYlabel]="true"
                    columnWidth="25%"
                    chart_type="area"
                    LegendPosition="top"
                    horizontalAlign="right"
                  ></app-bar-graph>
                </ng-template>
              </div>
            }
          </div>
        </div>

        <!-- Right Summary (20%) -->
        <div class="flex flex-col gap-5 md:col-span-4 xl:col-span-1">
          <!-- Temperature Summary -->
          <div class="p-4 rounded-xl shadow-lg flex flex-col flex-1 gap-2">
            <span class="font-bold"></span>
            <div class="grid grid-rows-2 gap-2 h-full">
              <div
                class="bg-red-50 rounded text-2xl text-red-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center gap-2 whitespace-nowrap">
                  <fa-icon [icon]="faTemperature4"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Highest Recorded Temperature</span
                  >
                </div>
                <p class="text-3xl">
                  {{
                    dashboardData?.SUMMARY?.MAX_TEMPERATURE | number: "1.2-2"
                  }}&deg;C
                </p>
                <p class="text-[10px] text-red-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MAX_TEMPERATURE_TIMESTAMP }}
                </p>
              </div>
              <div
                class="bg-red-50 rounded text-2xl text-red-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center gap-2 whitespace-nowrap">
                  <fa-icon [icon]="faTemperature0"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Lowest Recorded Temperature</span
                  >
                </div>
                <p class="text-3xl">
                  {{
                    dashboardData?.SUMMARY?.MIN_TEMPERATURE | number: "1.2-2"
                  }}&deg;C
                </p>
                <p class="text-[10px] text-red-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MIN_TEMPERATURE_TIMESTAMP }}
                </p>
              </div>
            </div>
          </div>

          <!-- Humidity Summary -->
          <div class="p-4 rounded-xl shadow-lg flex flex-col flex-1 gap-2">
            <span class="font-bold"></span>
            <div class="grid grid-rows-2 gap-2 h-full">
              <div
                class="bg-blue-50 rounded text-2xl text-blue-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center">
                  <fa-icon [icon]="faTemperature4"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Highest Recorded Humidity</span
                  >
                </div>
                <p class="text-3xl">
                  {{ dashboardData?.SUMMARY?.MAX_HUMIDITY | number: "1.2-2" }}%
                </p>
                <p class="text-[10px] text-blue-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MAX_HUMIDITY_TIMESTAMP }}
                </p>
              </div>
              <div
                class="bg-blue-50 rounded text-2xl text-blue-500 p-2 flex flex-col justify-between"
              >
                <div>
                  <fa-icon [icon]="faTemperature0"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Lowest Recorded Humidity</span
                  >
                </div>
                <p class="text-3xl">
                  {{ dashboardData?.SUMMARY?.MIN_HUMIDITY | number: "1.2-2" }}%
                </p>
                <p class="text-[10px] text-blue-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MIN_HUMIDITY_TIMESTAMP }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-8 flex justify-between w-full gap-5">
        <!-- Sensor Info Card (40%) -->
        <div
          class="w-[50%] bg-white rounded-xl shadow p-4 flex flex-col gap-4 max-h-[500px] overflow-y-auto"
        >
          <p class="font-bold text-gray-700 mb-2">Sensor Info</p>

          <div class="flex gap-2 flex-wrap">
            <div
              *ngFor="let tab of listTabs"
              (click)="onListTabChange(tab.slug)"
              [class.bg-primary-50]="activeSlugSensorTabs === tab.slug"
              [class.text-primary-600]="activeSlugSensorTabs === tab.slug"
              class="py-2 px-3 rounded-xl cursor-pointer text-center"
            >
              {{ tab.name }}
            </div>
          </div>

          <div
            *ngIf="activeSlugSensorTabs === 'sensorInfo'"
            class="flex flex-col gap-2 mt-2"
          >
            <div
              class="bg-primary-50 rounded-lg p-3 grid grid-cols-12 w-full h-[50px]"
            >
              <span class="col-span-5 font-bold my-auto text-primary"
                >Serial Number</span
              >
              <span class="col-span-7 font-semibold my-auto text-primary">{{
                selectedSensor?.serialNumber
              }}</span>
            </div>
            <div
              class="bg-primary-50 rounded-lg p-3 grid grid-cols-12 w-full h-[50px]"
            >
              <span class="col-span-5 font-bold my-auto text-primary"
                >IP Address</span
              >
              <span class="col-span-7 font-semibold my-auto text-primary">{{
                selectedSensor?.sensorIp
              }}</span>
            </div>
            <div
              class="bg-primary-50 rounded-lg p-3 grid grid-cols-12 w-full h-[50px]"
            >
              <span class="col-span-5 font-bold my-auto text-primary"
                >Sensor Type</span
              >
              <span class="col-span-7 font-semibold my-auto text-primary">{{
                selectedSensor?.sensorType
              }}</span>
            </div>
          </div>

          <div
            *ngIf="activeSlugSensorTabs === 'bins'"
            class="mt-2 overflow-x-auto"
          >
            <div
              *ngIf="coveredBins$ | async as coveredBins"
              class="flex flex-wrap gap-2"
            >
              <div
                *ngFor="let bin of coveredBins[0]?.coveredBins"
                class="font-semibold py-2 px-4 border text-primary rounded"
              >
                {{ bin.binNumber }}
              </div>
            </div>
          </div>

          <div *ngIf="activeSlugSensorTabs === 'configurations'" class="mt-2">
            <app-zone-sensor-alert></app-zone-sensor-alert>
          </div>
        </div>

        <!-- Sensor Image (20%) -->
        <div class="w-[50%] flex justify-center">
          <img
            class="rounded-lg h-[500px] w-full object-cover"
            [src]="selectedSensor?.posPicture"
            alt="Sensor Image"
          />
        </div>
      </div>

      <app-shared-layout> </app-shared-layout></div
  ></app-shared-layout>
</div>
